<a class="nav-link" [routerLink]="['./' + target]" routerLinkActive="active">
  <span>{{emoticon()}}</span>
  {{nameWithoutEmoticon()}}
</a>
<div class="bookmarks" *ngIf="basePath === target">
  <app-bookmark [bookmark]="bookmark" [editMode]="editMode" *ngFor="let bookmark of bookmarks"></app-bookmark>
</div>
